import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_USERS } from "./apiRoutes";

interface UseGetUserProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getUserById = async (id: string) =>
  await axiosAuth.get(`${GET_USERS}/${id}`);

const useGetUserByRole = ({
  id,
  queryParams,
}: UseGetUserProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["user", id],
    queryFn: () => getUserById(id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!id && (queryParams?.enabled ?? true),
  });
};

export default useGetUserByRole;
